<template>
  <nav class="container-nav">
    <ul>
      <li>
        <h2 v-html="transformedHeader" class="page-titles"></h2>
      </li>
      <div class="container-submenu">
        <ul>
          <li v-if="showPrices && !userHasInfiniteCredits">
            <span>${{ user.availableBudgetAmount || 0 }} available budget</span>
          </li>
          <li v-if="displayShoppingBag">
            <router-link
              :to="{ name: shoppingBagProducts.length ? 'ShoppingBag' : '' }"
              class="notification"
            >
              <img
                src="../assets/shopping-bag.svg"
                @click="goToShoppingBag"
                id="bag-svg"
              />
              <span class="badge" v-if="shoppingBagProducts.length > 0">{{
                shoppingBagProducts.length
              }}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </ul>

    <div v-if="displayStepper">
      <!-- Back Button here -->
      <div class="arrow-link" v-if="displayBack">
        <router-link :to="{ name: backTo || 'GiftList' }">
          <!-- <span>Back Main</span> -->
          <span class="inter">Back</span>
        </router-link>
      </div>

      <!-- Stepper Here -->
      <div v-if="shoppingBagProducts.length || displayStepper" class="stepper">
        <Stepper />
      </div>
    </div>
  </nav>
</template>

<script>
import { mapState } from 'vuex'
import Stepper from '@/components/Universal/Stepper'

export default {
  name: 'SendGiftMenu',
  props: {
    backTo: {
      type: String,
      default: ''
    },
    header: {
      type: String,
      default: ''
    },
    displayShoppingBag: {
      type: Boolean,
      default: true
    },
    displayStepper: {
      type: Boolean,
      default: false
    },
    displayBack: {
      type: Boolean,
      default: true
    }
  },

  components: { Stepper },

  computed: {
    transformedHeader() {
      return this.header.replace(/\*(.*?)\*/g, '<em>$1</em>')
    },
    userHasInfiniteCredits() {
      if (this.user.infiniteTeamUserBudget) {
        return true
      }
      return false
    },

    showPrices() {
      return this.$store.getters['team/showPrices']
    },

    ...mapState({
      shoppingBagProducts: state => state.order.shoppingBagProducts,
      user: state => state.profile.user
    })
  },

  methods: {
    goToShoppingBag() {
      if (this.shoppingBagProducts.length) {
        return this.$router.push({ name: 'ShoppingBag' })
      }
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/global.scss';
.container-nav {
  text-align: left;
}
nav {
  width: 100%;
  ul {
    list-style: none;
    display: flex;
    align-items: center;
    justify-content: space-between;
    li {
      width: 92%;
      line-height: 20px;
    }
  }
}
.container-submenu {
  ul {
    list-style: none;
    display: flex;
    justify-content: space-between;
    padding: 0;
  }
  li {
    margin-left: 2em;
  }
  li span {
    font-size: map-get($map: $heading-size, $key: five);
  }
}
.notification {
  position: relative;
}
.notification .badge {
  font-family: $inter;
  box-shadow: 0 0 1px #333;
  font-size: 10px;
  font-weight: bold;
  width: 20px;
  height: 20px;
  position: absolute;
  top: -6px;
  right: -5px;
  border-radius: 50%;
  background: $onyx;
  color: white;
  text-align: center;
}
</style>
